import React, { useState } from "react"
import { Container, SelectWrapper, Select, SelectArrow } from "./styles"

const AnnouncementDropdown = ({
  regularPrice,
  subscriptionPrice,
  buttonElement,
  buttonSubscriptionElement,
}) => {
  const [option, setOption] = useState("subscription-price")

  return (
    <Container data-experiment-id="dropdown">
      <SelectWrapper>
        <Select name="prices" value={option} onChange={(e) => setOption(e.target.value)}>
          <option value="subscription-price">{`Monthly: ${subscriptionPrice}`}</option>
          <option value="regular-price">{`Buy Once: $${regularPrice}`}</option>
        </Select>
        <SelectArrow width="7px" height="9px" id="arrow-down-icon" />
      </SelectWrapper>
      {option === "subscription-price" && buttonSubscriptionElement}
      {option === "regular-price" && buttonElement}
    </Container>
  )
}

export default AnnouncementDropdown
